import * as React from 'react';
export var defaultPageSize = false;
export var defaultCompactSize = false;
export var PageContext = React.createContext({
    fullWidth: defaultPageSize,
    compact: defaultCompactSize,
});
export var usePageContext = function () { return React.useContext(PageContext); };
